document.addEventListener('DOMContentLoaded', function () {
  const testMode = (window.byMalumadeTestSettings && window.byMalumadeTestSettings.popupReminder) === true;

  document.body.addEventListener('click', function (e) {
    const clickedEl = e.target;

    // Matcher quick-add, normal knap eller formular-submit
    const addButton = clickedEl.closest('.quick-add-btn, [name="add"], .product-form__submit');

    if (addButton) {
      if (!testMode && sessionStorage.getItem('popupShown')) return;

      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const cartContainsJewelryBox = cart.items.some(item =>
              item.product_type && item.product_type.toLowerCase() === 'smykkeskrin'
            );

            if (!cartContainsJewelryBox) {
              const popup = document.getElementById('jewelryBoxPopup');
              if (popup) {
                popup.classList.remove('popup-visible'); // reset animation
                void popup.offsetWidth; // trigger reflow
                popup.classList.add('popup-visible');

                if (!testMode) {
                  sessionStorage.setItem('popupShown', 'true');
                }
              }
            }
          })
          .catch(err => console.error('Fejl ved fetch af cart:', err));
      }, 3000);
    }
  });

  // Luk popup
  document.addEventListener('click', function (e) {
    if (e.target.id === 'closeJewelryPopup') {
      const popup = document.getElementById('jewelryBoxPopup');
      popup.classList.remove('popup-visible');
      popup.style.display = 'none';
    }
  });
});
